import Marty from "marty";
import NAV_CONSTANTS from "../constants/navConstants";

let navActions = Marty.createActionCreators({
    transitionTo(route, params, search) {
        this.dispatch(NAV_CONSTANTS.NAV_TRANSITION_TO, route, params, search);
    },
    toggleMenu(hide) {
        this.dispatch(NAV_CONSTANTS.NAV_TOGGLE_MENU, hide);
    },
    hideHeader() {
        this.dispatch(NAV_CONSTANTS.NAV_HIDE, "header");
    },
    hideFooter() {
        this.dispatch(NAV_CONSTANTS.NAV_HIDE, "footer");
    },
    hideBuyButton() {
        this.dispatch(NAV_CONSTANTS.NAV_HIDE, "buyButton");
    },
    showHeader() {
        this.dispatch(NAV_CONSTANTS.NAV_SHOW, "header");
    },
    showFooter() {
        this.dispatch(NAV_CONSTANTS.NAV_SHOW, "footer");
    },
    showBuyButton() {
        this.dispatch(NAV_CONSTANTS.NAV_SHOW, "buyButton");
    },
    confirm(message, confirm) {
        this.dispatch(NAV_CONSTANTS.NAV_MODAL_SHOW, "confirm", {message, confirm});
    },
    closeModal(name) {
        this.dispatch(NAV_CONSTANTS.NAV_MODAL_HIDE, name);
    }
});

export default navActions;



/** WEBPACK FOOTER **
 ** ./app/actions/navActions.js
 **/